import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { Close, Search, SearchOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { BaseButton } from '@lyearn/ui';
import { SearchBar } from '@/components/SearchBar';

import { inputStyles } from './styles';
import { AsyncFilterSearchProps } from './types';

const AsyncFilterSearch = (props: {
  search: AsyncFilterSearchProps;
  endAdornment?: React.ReactNode;
}) => {
  const { search, endAdornment } = props;
  const { isMobile } = useScreen();

  return (
    <SearchBar
      autoFocus
      appearance={search.appearance}
      className={cn({
        [inputStyles]: !isMobile,
        'rounded-8': !isMobile,
        'flex items-center justify-center border-none': isMobile,
      })}
      endAdornment={
        endAdornment ??
        (isMobile ? (
          <BaseButton
            className="h-24 w-28 min-w-0 rounded-full p-0"
            onClick={() => search.onChange('')}>
            <Close className="h-24 w-24" fillColorToken="icon-secondary" />
          </BaseButton>
        ) : null)
      }
      placeholder={search.placeholder}
      shape={search.shape || 'square'}
      size={search.size || 'medium'}
      startAdornment={
        isMobile ? (
          <Search className="h-24 w-24" fillColorToken="icon-secondary" />
        ) : (
          <SearchOutline className="h-20 w-20" fillColorToken="icon-placeholder" />
        )
      }
      value={search.value}
      variant={search.variant || (isMobile ? 'body-short-02' : 'body-short-01')}
      onChange={search.onChange}
    />
  );
};

export default React.memo(AsyncFilterSearch);
